import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions';
import { ListResultState, SortingBy, OrderBy } from '@rootCommon/types/common';
import { DeletedPatientListItem } from '@rootCommon/types/individual';

type Action = ActionType<typeof actions>;
export type RecoveryBinState = ListResultState<DeletedPatientListItem>;

const initState: RecoveryBinState = {
  data: null,
  loading: false,
  error: null,
  filter: { search: '', orderBy: OrderBy.DATE_DELETED, sorting: SortingBy.ASC },
};

export const recoveryBinReducer = (state = initState, action: Action): RecoveryBinState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchDeletedPatients.request):
      return { ...state, loading: true, error: null };
    case getType(actions.fetchDeletedPatients.success):
      return { ...state, loading: false, data: { items: action.payload, total: action.payload.length || 0 } };
    case getType(actions.fetchDeletedPatients.failure):
      return { ...state, loading: false, error: action.payload };

      // delete ids
    case getType(actions.permanentlyDeletePatients.request):
      return { ...state, loading: true, error: null };
    case getType(actions.permanentlyDeletePatients.success): {
      const items = state.data?.items ? [...state.data.items] : [];
      const newItems = items.filter((item) => !action.payload.includes(item.id));

      return { ...state, data: { items: newItems, total: newItems.length || 0 }, loading: false };
    }
    case getType(actions.permanentlyDeletePatients.failure):
      return { ...state, loading: false, error: action.payload };

      // recover ids
    case getType(actions.recoverDeletedPatients.request):
      return { ...state, loading: true, error: null };
    case getType(actions.recoverDeletedPatients.success): {
      const items = state.data?.items ? [...state.data.items] : [];
      const newItems = items.filter((item) => !action.payload.includes(item.id));

      return { ...state, data: { items: newItems, total: newItems.length || 0 }, loading: false };
    }
    case getType(actions.recoverDeletedPatients.failure):
      return { ...state, loading: false, error: action.payload };

      // filter
    case getType(actions.setDeletedPatientsFilter):
      return { ...state, filter: action.payload };

      // default
    default:
      return state;
  }
};

export default recoveryBinReducer;
